var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';
var CreateNewPasswordComponent = /** @class */ (function () {
    function CreateNewPasswordComponent(util, apiService, router, activatedRoute) {
        this.util = util;
        this.apiService = apiService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.isExistingUser = true;
        this.token = "";
        this.returnUrl = "";
        this.submitted = false;
        this.username = "";
        this.pin = "";
        this.userId = "";
        this.newPass = "";
        this.confirmPass = "";
        this.oldPassword = "";
        this.isResetSuccess = false;
        this.isConfirmPinSuccess = false;
        this.tmpUsername = "";
        this.tmpNewPass = "";
    }
    CreateNewPasswordComponent.prototype.ngOnInit = function () {
        //let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
        //this.username = cookieData["username"]
        //this.userId = cookieData["userId"]
        //this.roleData = JSON.parse(localStorage.getItem("role"))
        //this.returnUrl = localStorage.getItem("returnUrl")
        $("#createPass").addClass("sr-only");
    };
    CreateNewPasswordComponent.prototype.validateToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            token_id: this.token
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "GetUsernameFromToken", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.username = res.username;
                            this.token = res.token_id;
                            this.isExistingUser = true;
                        }
                        else {
                            this.util.ErrorDialog("ไม่พบข้อมูลการขอกำหนดรหัสผ่าน กรุณาลองใหม่อีกครั้ง");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateNewPasswordComponent.prototype.confirmPin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.pin.length > 0)) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        para = "pin=" + this.pin;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getUserCallCenterByPin", para)];
                    case 1:
                        user = _a.sent();
                        if (user.username != null) {
                            this.util.ShowWaiting(false);
                            this.username = user.username;
                            $("#divPin").addClass("sr-only");
                            $("#createPass").removeClass("sr-only");
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("รหัส Pin ผืดพลาด กรุณาตรวจสอบใหม่อีกครั้ง");
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CreateNewPasswordComponent.prototype.changePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var guidReq, guidRes, para, user, guidReq_1, guidRes_1, req, res, thisTs_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.newPass.length > 0 && this.newPass == this.confirmPass
                            && this.passwordValidation())) return [3 /*break*/, 9];
                        this.util.ShowWaiting(true);
                        guidReq = {
                            username: this.username
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "InsertChangeCallCenterPassToken", guidReq)];
                    case 1:
                        guidRes = _a.sent();
                        if (this.util.isSuccessResponse(guidRes) && guidRes.token_id != "") {
                            this.token = guidRes.token_id;
                        }
                        para = "username=" + this.username;
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                    case 2:
                        user = _a.sent();
                        if (!(user != null && user.length > 0)) return [3 /*break*/, 8];
                        if (!(user[0].dpa_customwebuserid != null && user[0].dpa_customwebuserid.toString().trim().length != 0)) return [3 /*break*/, 7];
                        guidReq_1 = {
                            dpa_customwebuserid: user[0].dpa_customwebuserid,
                            guid: this.token
                        };
                        this.oldPassword = user[0].dpa_password;
                        if (!(this.oldPassword == this.newPass)) return [3 /*break*/, 3];
                        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม");
                        return [3 /*break*/, 7];
                    case 3: return [4 /*yield*/, this.apiService.post("crmservice", "updateCallcenterGuid", guidReq_1)];
                    case 4:
                        guidRes_1 = _a.sent();
                        if (!(this.util.isSuccessResponse(guidRes_1) && guidRes_1.RESMSG == "SUCCESS")) return [3 /*break*/, 6];
                        req = {
                            //username: this.username,
                            newPassword: this.newPass,
                            //forcechangepassword: true,
                            guid: this.token
                        };
                        return [4 /*yield*/, this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req)];
                    case 5:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
                            this.isResetSuccess = true;
                            this.clear();
                            this.username = "";
                            this.util.ShowWaiting(false);
                            this.util.SuccessDialog("เปลี่ยน Password สำเร็จ");
                            thisTs_1 = this;
                            $('#btnSuccessOK').on('click', function () {
                                thisTs_1.router.navigate(['login']);
                            });
                            //this.DeleteToken(this.token);
                            //this.router.navigate(['login']);
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ");
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ");
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.util.ShowWaiting(false);
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CreateNewPasswordComponent.prototype.clear = function () {
        this.submitted = false;
        this.newPass = "";
        this.confirmPass = "";
    };
    CreateNewPasswordComponent.prototype.clearPin = function () {
        this.submitted = false;
        this.pin = "";
    };
    CreateNewPasswordComponent.prototype.close = function () {
        window.close();
    };
    CreateNewPasswordComponent.prototype.passwordValidation = function () {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass);
    };
    CreateNewPasswordComponent.prototype.DeleteToken = function (TokenID) {
        var ParamObj = {
            token_id: TokenID
        };
        this.apiService.postCustom("user", "deletetoken", ParamObj);
    };
    return CreateNewPasswordComponent;
}());
export { CreateNewPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/create-new-password/create-new-password.component.ts.pre-build-optimizer.js